﻿import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';

import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';

const domNodes = document.querySelectorAll<HTMLElement>('.gallery-wrapper');

domNodes.forEach(gallery => {
    const imagesJsonNode = document.querySelector(gallery.dataset.srcselector);
    const images = JSON.parse(imagesJsonNode.textContent) as ReactImageGalleryItem[];

    const element = (<ImageGallery items={images} showFullscreenButton={false} autoPlay={false} infinite={false} showPlayButton={false} showThumbnails={images.length > 1} thumbnailPosition={"bottom"} />);

    ReactDOM.render(element, gallery);
});